'use strict';

angular.module('controllers')
	.directive('dragDrop', ['$compile', '$parse', '$timeout', '$rootScope', function($compile, $parse, $timeout, $rootScope) {
		var timer = null;
		return {
			restrict: 'A',
			link: function (scope, element, attr, ctrl) {

                angular.element(element[0]).css('cursor', 'move');
				element.bind('dragstart', function (event) {

					var el = element[0];
					el.draggable = true;

					/*var elInput = angular.element(document.querySelectorAll('input'));
					console.log(elInput);
					angular.forEach(elInput, function (item, key) {
						elInput[key].addEventListener(
							'focus',
							function (event) {
								console.log('foc');
								elInput.closest('md-card').attr("draggable", false);
								return false;
							},
							false
						);
						elInput[key].addEventListener(
							'blur',
							function (event) {
								console.log('blur');
								elInput.closest('md-card').attr("draggable", true);
								return false;
							},
							false
						);
					});*/

					event.originalEvent.dataTransfer.effectAllowed = 'move';
					var style = window.getComputedStyle(event.target, null);
					event.originalEvent.dataTransfer.setData("text/plain",
						(parseInt(style.getPropertyValue("left"), 10) - event.originalEvent.clientX) + ',' + (parseInt(style.getPropertyValue("top"), 10) - event.originalEvent.clientY)+','+el.id);

					var body = angular.element(document).find('body')[0];
					//console.log(body);
					body.addEventListener(
						'dragover',
						function (event) {
							event.preventDefault();
							return false;
						},
						false
					);

					body.addEventListener(
						'drop',
						function (event) {

							var offset = event.dataTransfer.getData("text/plain").split(',');
							var dropElement = document.getElementById(offset[2]);
							var xpos = event.clientX + parseInt(offset[0], 10);
							var ypos = event.clientY + parseInt(offset[1], 10);

							if(dropElement !== null) {
								dropElement.style.left = (xpos) + 'px';
								dropElement.style.top = (ypos) + 'px';
							}
							//console.log(dropElement.style.left +'------'+dropElement.style.top)
							
							if (angular.isUndefined($rootScope.dropResult)) {
								$rootScope.dropResult = {};
							}
							$rootScope.dropResult[ offset[2]] = {'x':dropElement.style.left, 'y': dropElement.style.top}
													
							event.preventDefault();
							return false;
						},
						false
					);

				});

			}
		}
	}]);

